import React, {useEffect, useState} from "react";
import './index.scss';
import TwisterTile from "./twister-tile";
import InitialContext from "../../../state/static-data/InitialContext";

const widgetAttributes = InitialContext.getTwisterTileWidgetAttributes();
const firstElement = document.getElementById(widgetAttributes[0]?.idSelector);
const secondElement = document.getElementById(widgetAttributes[1]?.idSelector);

const initSelected = () => {
    //Today we only support 2 twister tile for Kyanite, we can expand here more if ever we have >2 twisters.
    return widgetAttributes[0]?.isSelected ? 0 : widgetAttributes[1]?.isSelected ? 1 : -1;
}

const TwisterTileWidget = () => {

    const [selectedTwister, setSelectedTwister] = useState(() => initSelected());

    useEffect(() => {
        switch (selectedTwister) {
            case 0:
                if (!!firstElement) {
                    firstElement.style.display = "block";
                }
                if (!!secondElement) {
                    secondElement.style.display = "none";
                }
                break;
            case 1:
                if (!!firstElement) {
                    firstElement.style.display = "none";
                }
                if (!!secondElement) {
                    secondElement.style.display = "block";
                }
                break;
            default:
                if (!!firstElement) {
                    firstElement.style.display = "none";
                }
                if (!!secondElement) {
                    secondElement.style.display = "none";
                }
        }
    }, [selectedTwister]);


    return (
        <pui-section class="twister-tile-widget" flowdirection="horizontal" spacingtop="med-large" fullwidth>
            {!!widgetAttributes[0] && <TwisterTile {...widgetAttributes[0]} position="left" isSelected={selectedTwister === 0}
                                                   onClick={() => setSelectedTwister(0)}/>}
            {!!widgetAttributes[1] && <TwisterTile {...widgetAttributes[1]} position="right" isSelected={selectedTwister === 1}
                                                   onClick={() => setSelectedTwister(1)}/>}
        </pui-section>
    )
}

export default TwisterTileWidget;